import Box from "./Box";
import React from "react";

function FilterMenuMaxHeightBox({ children }) {
  return (
    <Box maxHeight={200} overflow="auto">
      {children}
    </Box>
  );
}

export default FilterMenuMaxHeightBox;
